import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=fc7a9c60&scoped=true&"
import script from "./LanguageButton.vue?vue&type=script&lang=js&"
export * from "./LanguageButton.vue?vue&type=script&lang=js&"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=fc7a9c60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7a9c60",
  null
  
)

export default component.exports